import * as React from 'react';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';

export default function getAnchorForContextMenu(evt: React.MouseEvent<HTMLElement>): IPoint {
    if (evt.clientX || evt.clientY) {
        // The event had mouse coordinates, so use those
        return { x: evt.clientX, y: evt.clientY };
    } else {
        // The event had no mouse coordinates, likely because it was triggered by a key press
        // As such, we should calculate the anchor from the event target
        // Chrome, natively, will use the midpoint of the element in such situations, so let's just do the same
        let clientRect = evt.currentTarget.getBoundingClientRect();
        return {
            x: clientRect.left + clientRect.width / 2,
            y: clientRect.top + clientRect.height / 2,
        };
    }
}
